import classNames from 'classnames';
import { ReactNode } from 'react';
import {
    CalendarCell as RACalendarCell,
    CalendarCellProps as RACalendarCellProps,
} from 'react-aria-components';

import Mode from '../../types/Mode';

import styles from './CalendarCell.module.css';

type CalendarCellProps = Omit<RACalendarCellProps, 'className' | 'children'> & {
    children: ReactNode;
    selectingNewRange?: boolean;
    mode?: Mode;
    showDatesOutsideMonth?: boolean;
};

const CalendarCell = ({
    children,
    selectingNewRange = false,
    mode = 'single',
    showDatesOutsideMonth = false,
    ...props
}: CalendarCellProps) => {
    return (
        <RACalendarCell
            {...props}
            className={({ isSelected }) => {
                return classNames(styles.Root, {
                    [styles.singleMode]: mode === 'single',
                    [styles.allowSingleDayRange]: mode === 'singleOrRange',
                    [styles.partOfRange]: isSelected && !selectingNewRange,
                    [styles.showDatesOutsideMonth]: showDatesOutsideMonth,
                });
            }}
        >
            {children}
        </RACalendarCell>
    );
};

export default CalendarCell;
